let id = 1;
const formComponentsMixin = {
  inject: ['$validator'],
  props: {
    mutatedObject: {
      type: Object,
      required: true
    },
    field: {
      type: String,
      required: true
    },
    object: {
      type: Object,
      required: true
    },
    dataForm: {
      type: Object
    },
    name: {
      type: String
    },
    indexOfMutatedObject: Number,
    formVisibilityControl: String,
    additionalData: Object
  },
  data() {
    return {
      id: id++,
      storeId: this.$route.params.storeId
    };
  },
  filters: {
    capitalize(value) {
      if (!value) return '';
      return _.startCase(value);
    }
  },
  created() {
    if (this.object.default && 
        (!this.mutatedObject.hasOwnProperty([this.field]) 
        || !this.mutatedObject[this.field])) {
      this.$set(this.mutatedObject, this.field, this.object.default);
    }
  },
  methods: {
    filteredArrayForObjectArray(object) {
      return Object.entries(object).filter((items) => typeof items[1] === 'object');
    },
    setFieldCurrentTime(mutatedObject, field) {
      const time = moment().utc().format().replace(/Z$/, '+0000');
      this.$set(mutatedObject, field, time);
    }
  }
};

export { formComponentsMixin as default };
